
import Shell from "@shared/Shell";
import { useEffect, useState } from "react";
import usePreAuthURL from "@hooks/usePreAuthURL";
import log from "loglevel";
import {Spinner} from "@shared/Spinner";


export function Feedback() {

  const [open, setOpen] = useState(false)

  function start() {
    log.debug("Start interview");
    setOpen(true);
  }

  function close() {
    log.debug("Close interview");
    setOpen(false);
  }

  return (
    <Shell pageIndex={2}>
      <div className="mx-4 my-4 min-h-screen  ">
        {
          open ?

          <div>
            <Interview />
            <button 
            onClick={close}
            className="mt-12 justify-center rounded-md bg-gray-400 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-gray-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 dark:bg-gray-500 dark:shadow-none dark:hover:bg-gray-400 dark:focus-visible:outline-gray-500"
          >
            Close Interview
            </button>
          </div>
          :
          <div>
            <p>
              This new page interviews you, to learn more about how we can improve Topsham Quay Antiques Centre. <b>It is an experimental feature!</b>
            </p>
            <button 
              onClick={start}
              className="mt-16 justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500"
            >
              Start interview
            </button>
          </div>
        }

      </div>
    </Shell>
  );
}

function Interview() {
  const [verificationUrl, setVerificationUrl] = useState<string | null>(null);
  const [error] = useState<string | null>(null);
  //const checkIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const {isLoading, data} = usePreAuthURL();
  
  useEffect(() => {

    if (!isLoading) {
      log.info("URL=", data)
      setVerificationUrl(data);
    }
    return () => {
    };
  }, [data, isLoading]);


  // Listen for completion message from iframe
  useEffect(() => {
    if (!verificationUrl) return;

    const handleMessage = (event: MessageEvent) => {
      // Verify the origin matches the iframe URL
      const urlObj = new URL(verificationUrl);
      if (event.origin !== urlObj.origin) return;

      // Check for completion event
      if (event.data?.type === 'interview_completed' || event.data?.completed) {
        console.log('Interview completed via postMessage');
        window.location.href = '/completed';
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [verificationUrl]);


  if (isLoading) {
    return (
      <div className="flex min-h-screen justify-center">
        <div className="text-center">
          
          <div className="bg-white text-slate-500 h-32 w-32">
            <Spinner spin={true}/>
          </div> 
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex min-h-screen justify-center">
        <div className="text-center">
          <p className="text-destructive mb-2">Tell Jasper it didnt work - unknown error!</p>
          <p className="text-muted-foreground">{error}</p>
        </div>
      </div>
    );
  }

  if (!verificationUrl) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-muted-foreground">Tell Jasper it didnt work - there was no verification URL!</p>
      </div>
    );
  }

  log.debug('About to load iframe with URL:', verificationUrl);
  
  // Extract the origin from the verification URL
  const urlObj = new URL(verificationUrl);
  const iframeOrigin = urlObj.origin;
  console.log('Iframe origin:', iframeOrigin);

  return (
      <div className="w-full max-w-3xl rounded-xl  shadow overflow-hidden">
        <div className="relative h-[60vh] md:h-[70vh]">
          <iframe
            src={verificationUrl}
            className="absolute inset-0 h-full w-full border-0"
            title="Interview for Topsham Quay Antiques"
            allow="camera; microphone; fullscreen; clipboard-read; clipboard-write"
            referrerPolicy="origin"
            onLoad={() => {
              console.log('Iframe loaded successfully');
            }}
            onError={(e) => console.error('Iframe load error:', e)}
          />
        </div>
      </div>
  );
}


export default Feedback;
